<template>
    <transition name="layout-fade">
        <loader v-if="loader"/>
        <v-layout column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>
                    {{ customer.name }} <br/>
                    {{ customer.phone | formatPhone }}
                </v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-layout>
                    <v-flex xs4>
                        <v-layout column>
                            <v-flex xs12>
                                <v-subheader class="pa-0">Имя пользователя</v-subheader>
                                <v-text-field
                                    v-model="customer.name"
                                    readonly
                                    single-line
                                    text
                                    solo/>
                            </v-flex>
                            <v-flex xs12>
                                <v-subheader class="pa-0">Дата рождения</v-subheader>
                                <v-text-field
                                    v-model="customer.birthday"
                                    readonly
                                    single-line
                                    text
                                    solo/>
                            </v-flex>
                            <v-flex xs12>
                                <v-subheader class="pa-0">Дата регистрации</v-subheader>
                                <v-text-field
                                    v-model="customer.created_at"
                                    readonly
                                    single-line
                                    text
                                    solo/>
                            </v-flex>
                            <v-flex xs12>
                                <v-layout>
                                    <v-flex xs3>
                                        <v-subheader class="pa-0">Пол</v-subheader>
                                        <v-text-field
                                            v-model="customer.sex"
                                            readonly
                                            single-line
                                            text
                                            solo/>
                                    </v-flex>
                                    <v-spacer/>
                                    <v-flex xs8>
                                        <v-subheader class="pa-0">Кол-во бонусов</v-subheader>
                                        <v-text-field
                                            v-model="customer.bonus"
                                            readonly
                                            single-line
                                            text
                                            solo/>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12>
                                <v-subheader class="pa-0">Последнее устройство</v-subheader>
                                <v-text-field
                                    v-if="customer.last_device !== null"
                                    v-model="customer.last_device.device_name"
                                    readonly
                                    single-line
                                    text
                                    solo/>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs7 v-if="customer.orders.length">
                        <v-subheader class="pa-0">История заказов</v-subheader>
                        <orders :orders="customer.orders"/>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Customer from '../../../api/customer'
    import Orders from './Components/Orders'
    import Loader from '../../../components/Loader/Layout'

    export default {
        name: 'editCustomer',
        components: {
            Orders,
            Loader
        },
        data: () => ({
            loader: false,
            loading: false,
            customer: {
                name: '',
                phone: '+998901234567',
                birthday: null,
                created_at: null,
                sex: null,
                bonus: 0,
                last_device: null,
                orders: [],
                bookings: []
            }
        }),
        mounted () {
            this.getCustomer(this.$route.params.customerId)
        },
        methods: {
            getCustomer (id) {
                this.loader = true

                Customer
                    .getById(id)
                    .then(response => {
                        this.customer = response.data.data
                        this.customer.birthday = this.$options.filters.formatDate(this.customer.birthday * 1000)
                        this.customer.created_at = this.$options.filters.formatDate(this.customer.created_at)
                        this.customer.sex = this.customer.sex === 1 ? 'M' : 'Ж'
                        this.customer.bonus = this.$options.filters.formatPrice(this.customer.bonus)
                    })
                    .catch(error => {
                        this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                        this.$router.push({ name: 'customerRoot' })
                    })
                    .finally(() => this.loader = false)
            },
            sendForm () {

            }
        },
        beforeRouteLeave (to, from, next) {
            next()
        },
        beforeRouteUpdate (to, from, next) {
            this.customer = this.getCustomer(to.params.customerId)
            next()
        }
    }
</script>
